// src/App.tsx or NotificationListener.tsx
import { useEffect } from 'react';
import { getMessaging, onMessage } from 'firebase/messaging';
import firebaseApp from './firebase';
import { toast } from "react-toastify";
import NotificationToast from '../components/landing/Admin/Notifications/Notification';
import { setChatCount } from '../ducks/gateway/login/actions';
import { useDispatch, useSelector } from "react-redux";

const messaging = getMessaging(firebaseApp);

function NotificationListener() {
    const dispatch = useDispatch();
    const userState = useSelector((state) => state.user.auth);
    const { chatCount } = userState;
    const { user_id, first_name, last_name } = userState?.userInfo || {};

    const audio = new Audio("/notification_tone.mp3");
    audio.volume = 0.8;
    audio.preload = "auto";

    useEffect(() => {
        onMessage(messaging, (payload) => {
            console.log(payload);
            const { title, body } = payload.notification || {};
            // Play sound
            if (user_id === "") {
                return;
            }

            console.log("Check Log..........................................");
            console.log(title);
            console.log(`${first_name} ${last_name}`);
            console.log("End Log..........................................");
            if (title !== `${first_name} ${last_name}`) {
                return;
            }

            audio.play().catch(e => console.warn("Notification sound play failed:", e));
            var _chatCount = chatCount + 1;
            dispatch(setChatCount(_chatCount));
            document.title = `${_chatCount > 0 ? `(${_chatCount}) ` : ''}New Notification`;
            toast.info(
                <NotificationToast
                    title={title}
                    description={body}
                />
                , {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
        });
    }, []);

    return null;
}

export default NotificationListener;
